var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TunePostbackTracker {
  constructor(opts) {
    __publicField(this, "pendingRequests", /* @__PURE__ */ new Set());
    this.opts = opts;
  }
  getTrackingQueryParams() {
    return {};
  }
  setUserID() {
  }
  setUserProperties() {
  }
  track(eventName) {
    const { transactionId, tuneEndpoint } = this.opts;
    const pendingRequest = fetch(
      `${tuneEndpoint}/aff_goal?a=lsr&goal_name=${eventName.toLowerCase()}&adv_id=0&transaction_id=${transactionId}`
    );
    this.pendingRequests.add(pendingRequest);
    void pendingRequest.finally(() => {
      this.pendingRequests.delete(pendingRequest);
    });
  }
  trackRevenue() {
    this.track("Revenue");
  }
  async flush() {
    await Promise.all(this.pendingRequests);
  }
}
export {
  TunePostbackTracker
};
